export default "__VITE_ASSET__BWEl0Hua__"